import { AfterViewInit, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SetTable } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-sample-table',
  templateUrl: './sample-table.component.html',
  styleUrls: ['./sample-table.component.scss']
})
export class SampleTableComponent implements OnInit, AfterViewInit {

  @Input() block: SetTable = {} as SetTable;
  tabella: string = '';

  constructor(private helperService: HelpersService, 
              private renderer: Renderer2) { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.helperService.setStyleTables(this.renderer);
  }

}
